"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getGlobalFromWindow = function getGlobalFromWindowHelper(key) {
  var _window = window,
      seMarketplace = _window.seMarketplace;

  if (!seMarketplace || !Object.hasOwnProperty.call(seMarketplace, 'site_globals') || !Object.hasOwnProperty.call(seMarketplace.site_globals, key)) {
    return '';
  }

  return window.seMarketplace.site_globals[key];
};

var _default = getGlobalFromWindow;
exports["default"] = _default;